import { useQuery } from "@tanstack/react-query";
import { exciseWarehouseKeys } from "./exciseWarehouse.keys";
import { exciseWarehouseService } from "./exciseWarehouse.service";
import { ExciseWarehouse } from "./exciseWarehouse.types";

/**
 * Hook used to fetch data for excise warehouse list
 * @param filters Filters applied to table data
 * @param enabled If true API call is initiated immediately
 * @returns Filter dropdown values that can be applied to data and data after/before data
 */
export function useExciseWarehouseRequestList({
  enabled,
}: {
  enabled?: boolean;
}) {
  return useQuery({
    ...exciseWarehouseKeys.exciseWarehouseList(),
    queryFn: exciseWarehouseService.getSvaAkciznaSkladistaZaDrustvo,
    select: (response): Array<ExciseWarehouse> => response?.data ?? [],
    retry: false,
    enabled,
  });
}
